export function ordinal(value: number): string {
  const possibleOrdinals = ['th', 'st', 'nd', 'rd'];
  const normalizedNumber = value % 100;
  return (
    value +
    (possibleOrdinals[(normalizedNumber - 20) % 10] ||
      possibleOrdinals[normalizedNumber] ||
      possibleOrdinals[0])
  );
}
export function formatMilliseconds(ms: number) {
  let seconds = Math.floor(ms / 1000);

  if (seconds < 60) {
    return `${seconds} seconds`;
  } else {
    const minutes = Math.floor(seconds / 60);
    seconds = seconds % 60;
    return seconds > 0 ? `${minutes} minutes, ${seconds} seconds` : `${minutes} minutes`;
  }
}

export function pluralize(text: string, count: number): string {
  return `${text}${count > 1 ? 's' : ''}`;
}

export function isEllipsisActive(e: HTMLDivElement | null): boolean {
  if (!e) return false;
  return e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth;
}

export function compareNames(
  a?: { firstName?: string; lastName?: string },
  b?: { firstName?: string; lastName?: string },
): number {
  const { firstName: firstA = '', lastName: lastA = '' } = a || {};
  const { firstName: firstB = '', lastName: lastB = '' } = b || {};

  const lastCompare = lastA.localeCompare(lastB, undefined, { sensitivity: 'base' });
  if (lastCompare !== 0) return lastCompare;

  return firstA.localeCompare(firstB, undefined, { sensitivity: 'base' });
}
